module.exports = __webpack_public_path__ + "static/private-cloudfront-config-2-7306037be6e8c35beb705103c42dc9c0.png";